import { ONE_PLATFORM_ERROR, ONE_PLATFORM_HIDE_ERROR, ONE_PLATFORM_START_LOADER, ONE_PLATFORM_STOP_LOADER, ONE_PLATFORM_ADD_MSG, ONE_PLATFORM_CLEAR_MSG, } from "../../interfaces/common/iCommon";
const initState = {
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: null,
        show: false,
        icon: null,
    },
};
const commonOnePlatFormReducer = (state = initState, action) => {
    switch (action.type) {
        case ONE_PLATFORM_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ONE_PLATFORM_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case ONE_PLATFORM_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ONE_PLATFORM_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case ONE_PLATFORM_ADD_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case ONE_PLATFORM_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        default:
            return Object.assign({}, state);
    }
};
export default commonOnePlatFormReducer;
